
export function formatOrderId(id: number): string {
    return `#OR-${id.toString().padStart(3, '0')}`;
}

export default formatOrderId;
